import { computed } from 'vue'

import { useClientOnlyComputedBreakpoint } from '@backmarket/utils/composables/useClientOnlyComputedBreakpoint'
import { Breakpoint } from '@backmarket/utils/dom/getCurrentBreakpoint'

export const useScreenSize = () => {
  const breakpoint = useClientOnlyComputedBreakpoint()
  const isSmallScreen = computed(() => breakpoint.value < Breakpoint.LG)

  return { isSmallScreen }
}
